import React from "react";
import { FeatherCheckCircle2, FeatherSquare } from "@subframe/core";
import { TaskRowView } from "../viewmodels/buildTaskGroups";

interface TaskRowProps {
  row: TaskRowView;
  onSelect: (row: TaskRowView) => void;
}

/**
 * One line in a task group.
 *
 * Actionable rows are clickable and carry an empty checkbox glyph. Done rows are
 * muted and inert — there is nothing to open, so they are not focusable and do
 * not pretend to be buttons.
 */
export const TaskRow: React.FC<TaskRowProps> = ({ row, onSelect }) => {
  if (row.done) {
    return (
      <div className="flex w-full items-center gap-3 border-b border-solid border-neutral-100 px-1 py-3 last:border-b-0">
        <FeatherCheckCircle2 className="text-body font-body text-neutral-300" />
        <span className="text-body font-body text-neutral-400">{row.label}</span>
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(row)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect(row);
        }
      }}
      className="flex w-full cursor-pointer items-center gap-3 rounded-md border-b border-solid border-neutral-100 px-1 py-3 last:border-b-0 hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary"
    >
      <FeatherSquare className="text-body font-body text-neutral-400" />
      <span className="text-body font-body text-default-font">{row.label}</span>
    </div>
  );
};
